import React from 'react';

import { css, cx } from '@emotion/css';
import { Tab, Tabs, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PatientListData } from '@/hooks/usePatientsListData.ts';
import { useStyles } from '@/hooks/useStyles';
import { TabIcon } from '@/uiKit/atoms/TabIcon';

export type PatientListMenuItems = 'monitored' | 'gestational' | 'all';

export type PatientListMenuProps = {
  selectedItem: PatientListMenuItems;
  selectItem: (item: PatientListMenuItems) => void;
  patientListData: PatientListData;
  className?: string;
};

export const PatientListMenu: React.FC<PatientListMenuProps> = ({
  selectedItem,
  selectItem,
  patientListData,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Tabs
      id="patient-list-menu"
      value={selectedItem}
      onChange={(_, value) => selectItem(value)}
      variant="scrollable"
      scrollButtons="auto"
      className={cx(styles.container, className)}
    >
      <Tab
        id="patient-list-menu-dt1-dt2"
        label={t('pages.patients.monitored')}
        icon={
          <TabIcon
            selected={selectedItem === 'monitored'}
            count={patientListData.monitored.length}
          />
        }
        iconPosition="end"
        value="monitored"
      />
      <Tab
        id="patient-list-menu-gestational"
        label={t('pages.patients.gestational')}
        icon={
          <TabIcon
            selected={selectedItem === 'gestational'}
            count={patientListData.gestational.length}
          />
        }
        iconPosition="end"
        value="gestational"
      />
      <Tab
        id="patient-list-menu-all"
        label={t('pages.patients.all')}
        icon={
          <TabIcon
            selected={selectedItem === 'all'}
            count={patientListData.all.length}
          />
        }
        iconPosition="end"
        value="all"
      />
    </Tabs>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  label: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(4)};
    align-items: center;
    flex-wrap: nowrap;
    text-wrap: nowrap;
  `,
});
